import { normalizeSubstring } from "./helpers/normalize";
// Result of running getManufacturerList
export const mouserManufacturerList = {
    "3M": 4294764013,
    "4D Systems": 4292488353,
    "Adesto Technologies": 4291718704,
    "ADLINK Technology": 4292487161,
    "Advanced Energy": 4248033026,
    "Advanced Linear Devices": 4294759240,
    "Advanced Semiconductor, Inc.": 4292488675,
    "Advanced Thermal Solutions": 4290802272,
    "AIM - American Iron and Metal": 4294759011,
    "Alliance Memory": 4292767663,
    "Alorium Technology": 4261356189,
    "Alpha (Taiwan)": 4294759271,
    "Alpha Wire": 4294762872,
    "Alps Alpine": 4294759270,
    "Altitude Technology": 4248121084,
    "Amulet Technologies": 4294759198,
    "Analog Devices Inc.": 4290538360,
    "ANAVI Technology": 4245130123,
    "Anderson Power Products": 4292800521,
    "Andes Technology": 4243894264,
    "Anvo-Systems Dresden": 4247468337,
    "AP Memory Technology": 4242669983,
    "Apex Microtechnology": 4245201694,
    "Apex Tool Group": 4292809702,
    "API Delevan": 4294759174,
    "API Technologies": 4289460557,
    "APM HEXSEAL": 4294759267,
    "Applied Motion": 4294759266,
    "ARBOR Technology": 4294759238,
    "Aries Electronics": 4289636624,
    "Artesyn Embedded Technologies": 4288194909,
    "Astera Labs": 4245046395,
    "Astrodyne TDI": 4248489716,
    "Atollic Inc.": 4291708244,
    "Avalanche Technology": 4244568552,
    "Avery Dennison": 4294759018,
    "B&K Precision": 4294759237,
    "B+B SmartWorx": 4291501706,
    "Bare Conductive": 4244701006,
    "Bel Power Solutions": 4284645137,
    "Belden Wire & Cable": 4294014069,
    "Bellin Dynamic Systems": 4294759014,
    "Bend Labs": 4246683966,
    "Bergquist Company": 4292714930,
    "BIAS Power": 4292827291,
    "BJB Electric": 4247786309,
    "Bomar Interconnect": 4294759212,
    "Boreas Technologies": 4243781664,
    "Boundary Devices": 4290656814,
    "Broadcom Limited": 4294759247,
    "Bud Industries": 4292986705,
    "BusBoard Prototype Systems": 4293990566,
    "C&K Switches": 4294758777,
    "Cal Test Electronics": 4248131330,
    "Capacitech Energy": 4243886916,
    "Carling Technologies": 4294759692,
    "Carlo Gavazzi": 4245516442,
    "Central Semiconductor": 4294758883,
    "Chip Quik": 4292779092,
    "Cinch Connectivity Solutions": 4284645234,
    "Cirrus Logic": 4294449078,
    "CMD / ON Semiconductor": 4292882814,
    "CML Microcircuits": 4246326971,
    "Comchip Technology": 4292981920,
    "Connective Peripherals": 4294759216,
    "Cornell Dubilier": 4294759263,
    "Coto Technology": 4294759262,
    "Cowfish Studios": 4243774950,
    "Cree LED": 4242733322,
    "Cree, Inc.": 4292733696,
    "Critical Link": 4292779773,
    "Crocus Technology": 4253573165,
    "Crowd Supply": 4248270523,
    "CUI Devices": 4246260295,
    "CUI Inc.": 4246343149,
    "CW Industries": 4294759261,
    "Cypress Semiconductor": 4294014452,
    "D3 Semiconductor": 4248598890,
    "Daniels Manufacturing": 4256412820,
    "DAVE Embedded Systems": 4277744737,
    "Davies Molding": 4294759260,
    "DB Unlimited": 4284703227,
    "DBM Optix": 4285752948,
    "Delta Electronics": 4285169676,
    "Desco Tools": 4282307745,
    "Design Gateway": 4248594198,
    "Dialog Semiconductor": 4272876899,
    "Digital View": 4294759215,
    "Diode Laser Concepts": 4294759197,
    "Diodes Incorporated": 4288463162,
    "DLP Design": 4294759236,
    "Doodle Labs": 4248121056,
    "e-peas": 4244960936,
    "E-Switch": 4294759258,
    "E-T-A Circuit Breakers": 4258121642,
    "Eagle Plastic Devices": 4294759690,
    "Eagle-Picher": 4294759082,
    "ebm-papst": 4294759021,
    "eCOUNT Embedded": 4247429181,
    "ELECTRONIC ASSEMBLY": 4294027454,
    "Elprotronic Inc.": 4293991641,
    "Embedded Artists": 4292766022,
    "EMO Systems": 4246700384,
    "Envox Experimental Zone": 4242467956,
    "EPCOS / TDK": 4281990696,
    "ERNI Electronics": 4287993666,
    "ERP Power": 4249744740,
    "Esico-Triton": 4294759204,
    "ESS Technology": 4244991966,
    "ETA-USA": 4294759079,
    "ETI Systems": 4294759249,
    "Everspin Technologies": 4292725692,
    "Excamera Labs": 4243887082,
    "F-Secure": 4245129715,
    "Fair-Rite": 4294759170,
    "FCI / Amphenol": 4294759256,
    "First Sensor": 4290024662,
    "Future Designs, Inc. (FDI)": 4294409272,
    "GaN Systems": 4285500034,
    "GeneSiC Semiconductor": 4292829759,
    "GHI Electronics": 4292700835,
    "Global Connector Technology (GCT)": 4242728917,
    "Global Specialties": 4294758892,
    "Gold Peak": 4294758891,
    "Gowanda Electronics": 4294758936,
    "GSI Technology": 4248732235,
    "Guerrilla RF": 4257599929,
    "HALO Electronics": 4282024261,
    "Halo Microelectronics": 4243057217,
    "Hatch Lighting": 4242647217,
    "HDP Power": 4246399568,
    "Hendon Semiconductors": 4294400029,
    "Hirose Electric": 4294014051,
    "Hitachi Metals": 4247266274,
    "HUBER+SUHNER": 4248623183,
    "I-SYST": 4244628993,
    "IAR Systems": 4294027435,
    "ICE Components": 4292817255,
    "IET Labs": 4294758970,
    "II-VI": 4290462436,
    "Imagination Technologies": 4260013979,
    "Industrial Shields": 4246660157,
    "Insight SiP": 4248284622,
    "Inspired LED": 4292859497,
    "International Power": 4294758800,
    "Inventek Systems": 4247515881,
    "Inventus Power": 4266967763,
    "IQD Frequency Products": 4249738778,
    "Iso-Tip": 4294758636,
    "ITT Cannon": 4248588326,
    "ITW Switches": 4294758850,
    "iWave Systems": 4245110761,
    "JAE Electronics": 4294758864,
    "Jewell Modutec": 4294758574,
    "JKL Components": 4294759178,
    "Johnson Electric": 4246718630,
    "Jonard Industries": 4276089310,
    "Ka-Ro electronics": 4288985402,
    "Keithley Instruments, Inc.": 4291943470,
    "Keystone Electronics": 4294759104,
    "Kinetic Technologies": 4247522834,
    "Klein Tools": 4245512298,
    "KOA Speer": 4294759671,
    "Konica Minolta": 4245407098,
    "Laird Connectivity": 4246824425,
    "Laird Performance Materials": 4246824431,
    "Laird Thermal Systems": 4246823242,
    "Lambda Nu": 4243391403,
    "Landzo Electronic Technology": 4247489745,
    "LED Engin": 4289671003,
    "LedLink Optics": 4292727334,
    "Leopard Imaging": 4292755918,
    "Linx Technologies": 4293991644,
    "Lite-On": 4294758822,
    "LMB/Heeger": 4294758835,
    "Lumberg Automation": 4248292261,
    "Luminus Devices": 4292825949,
    "Luxo Corporation": 4294758789,
    "Macraigor Systems": 4292758222,
    "Mallory Sonalert": 4294758854,
    "Marktech Optoelectronics": 4242731583,
    "Marlow Industries, Inc.": 4242467826,
    "Masach Tech": 4247490713,
    "Matrix Industries": 4246688229,
    "Matrix Orbital": 4294758821,
    "Maxim Integrated": 4291596096,
    "Maxwell Technologies": 4293982170,
    "MEAN WELL": 4294759007,
    "Medium One": 4247900044,
    "Merit Sensor": 4266629056,
    "MG Chemicals": 4294758846,
    "Micro Commercial Components (MCC)": 4292768617,
    "Micro Crystal": 4294758788,
    "Micron Technology": 4248112315,
    "Microtips Technology": 4294758760,
    "MIL Tools": 4279137857,
    "Mill-Max": 4294758771,
    "Mini-Circuits": 4245909746,
    "MinnowBoard by CircuitCo": 4274386079,
    "Mitsubishi Electric": 4292765876,
    "Modulo Labs": 4247552885,
    "Monolithic Power Systems (MPS)": 4292703012,
    "Mountain Switch": 4294759091,
    "Mueller Electric": 4294758829,
    "MYIR Tech": 4247520753,
    "National Instruments": 4284795778,
    "NetPower Technologies": 4294758696,
    "Neutron Controls": 4245052618,
    "New Age Enclosures": 4294406521,
    "New Energy": 4253660069,
    "NewAE Technology": 4248083623,
    "Newhaven Display": 4294758755,
    "NKK Switches": 4294012386,
    "NMB Technologies": 4273711657,
    "Nordic Semiconductor": 4292713435,
    "Octavo Systems": 4248685086,
    "ODU USA": 4247283206,
    "Olimex Ltd.": 4292825757,
    "ON Semiconductor": 4294759663,
    "Orion Fans": 4294000039,
    "OSEPP Electronics": 4248457961,
    "Osram Opto Semiconductor": 4293994460,
    "Overview Ltd.": 4242697992,
    "PANJIT Touch Screens": 4294576708,
    "Parker LORD": 4244610475,
    "Performance Motion Devices": 4245104286,
    "Pervasive Displays": 4245049529,
    "Phoenix Contact": 4294759378,
    "Power Integrations": 4294758653,
    "Power-Sonic": 4294758698,
    "Preci-dip": 4249710940,
    "Pro-Wave Electronics": 4247492570,
    "Protektive Pak": 4294758687,
    "PUI Audio": 4292975598,
    "Qualcomm RF360": 4248636250,
    "RAF Electronic Hardware": 4292891802,
    "Raspberry Pi": 4248643958,
    "Raydiall Automotive": 4244630476,
    "Red Pitaya": 4272876854,
    "ReFLEX CES": 4248634629,
    "Renesas Electronics": 4250705177,
    "RF Solutions": 4246695391,
    "Ricoh Electronics": 4253249948,
    "ROHM Semiconductor": 4294005660,
    "Rowley Associates": 4292729611,
    "RRC Power Solutions": 4247809170,
    "Samsung Electro-Mechanics": 4248637428,
    "Sanyo Denki": 4291812862,
    "Sargent Tools": 4294760102,
    "Schneider Electric": 4290493392,
    "Seeed Studio": 4273832515,
    "Segger Microcontroller": 4292731858,
    "Seiko Instruments": 4294764005,
    "Seoul Semiconductor": 4294762567,
    "Sfera Labs": 4248515802,
    "SharksCove by CircuitCo": 4274385538,
    "Sharp Microelectronics": 4294764024,
    "Shin Chin": 4294764128,
    "Sierra Monitor": 4248137909,
    "Silex Technology": 4294763721,
    "Silicon Laboratories": 4294763905,
    "Silicon Microstructures": 4291359918,
    "Skeleton Technologies": 4244892242,
    "SkyHigh Memory": 4246816589,
    "SL Power": 4292859927,
    "SMART Modular Technologies": 4273040524,
    "SMART Wireless Computing": 4247872641,
    "Smiths Interconnect": 4263162880,
    "Solantro Semiconductor": 4247293555,
    "Song Chuan": 4294763970,
    "SparkFun Electronics": 4249745770,
    "Spectra Symbol": 4292984436,
    "Sprague Goodman": 4294762170,
    "SST Sensing": 4246705279,
    "Standex Electronics": 4291381349,
    "Stanley Electric": 4246705242,
    "Storm Interface": 4279076258,
    "Struthers-Dunn": 4294764053,
    "Sudo Systems": 4247902564,
    "Superior Sensor Technology": 4246737302,
    "Symmetry Electronics": 4248104150,
    "Tadiran Batteries": 4291307500,
    "Taiwan Semiconductor": 4294758695,
    "Taiyo Yuden": 4292690431,
    "TDK-Lambda": 4292564578,
    "TE Connectivity Divested": 4248699667,
    "TE Connectivity": 4292733690,
    "Teledyne LeCroy": 4292039356,
    "Teledyne Relays": 4294758780,
    "Tempo Semiconductor": 4287869701,
    "Texas Instruments": 4294759686,
    "THAT Corporation": 4294758876,
    "Theobroma Systems": 4246805765,
    "Torex Semiconductor": 4253667227,
    "TRACO Power": 4282957187,
    "Trenz Electronic": 4245420893,
    "Tri-Star Electronics": 4292483073,
    "Triad Magnetics": 4294759159,
    "Tripp Lite": 4294758889,
    "TT Electronics": 4285624292,
    "TTI, Inc Assembly": 4245457654,
    "Tusonix / CTS": 4294758483,
    "Twin Industries": 4294758774,
    "TXC Corporation": 4292752712,
    "u-blox": 4246009371,
    "Unexpected Maker": 4244734602,
    "United Chemi-Con (UCC)": 4294758952,
    "Universal Lighting Technologies": 4245194703,
    "VIA Technologies": 4253503446,
    "Vishay Precision Group": 4292826587,
    "Vision Components": 4242465453,
    "Vision-Luxo": 4248512952,
    "VORAGO Technologies": 4256189531,
    "Wakefield-Vette": 4294758572,
    "WeEn Semiconductors": 4248635120,
    "Well Buying": 4292906444,
    "Western Design Center (WDC)": 4292713940,
    "What's Next": 4247850791,
    "White-Rodgers": 4292567663,
    "Wilderness Labs": 4291281188,
    "Wurth Elektronik": 4294014164,
    "XP Power": 4246803669,
    "Yamaichi Electronics": 4292728618,
    "Zentel Japan": 4242476605,
    "ZF Electronics": 4248721437,
    AAEON: 4248630788,
    Aavid: 4294760160,
    ABB: 4292120057,
    ABLIC: 4248148511,
    ABRACON: 4294762294,
    Acconeer: 4242856513,
    ACEINNA: 4247825064,
    aconno: 4248482617,
    Adafruit: 4274387497,
    ADDA: 4294759022,
    Advantech: 4284836075,
    AEM: 4294759391,
    Afero: 4267544821,
    AirBorn: 4278401346,
    Akustica: 4278921334,
    Altech: 4294759664,
    Ametherm: 4290813042,
    Amphenol: 4294764080,
    AMPROBE: 4294758869,
    ams: 4291852130,
    AMSECO: 4294759269,
    Anaren: 4292827190,
    Antenova: 4294759222,
    Apacer: 4292827925,
    Apem: 4294759268,
    Aptiv: 4294759211,
    Arduino: 4292821466,
    ArduSimple: 4245220481,
    ATLAS: 4244640273,
    ATOP: 4242900782,
    Auvidea: 4248452192,
    Aven: 4245914261,
    AVX: 4294759694,
    Axiomtek: 4288902482,
    Azoteq: 4292709215,
    Basler: 4248503136,
    BeagleBoard: 4292985733,
    BECOM: 4290247687,
    Bel: 4284634897,
    Benewake: 4244615585,
    BIVAR: 4294759244,
    Blackhawk: 4293990214,
    Bosch: 4267065231,
    Bourns: 4294759693,
    Brainboxes: 4246115917,
    Bridgetek: 4248472993,
    Bulgin: 4294759390,
    Caddock: 4294759167,
    Califia: 4292694678,
    Caplugs: 4248014066,
    Carclo: 4292583535,
    CCS: 4294759219,
    CEL: 4294758861,
    Chemtronics: 4294759019,
    CHERRY: 4288434773,
    Chipsee: 4243734818,
    Cincon: 4294759087,
    Cirque: 4248124793,
    Citel: 4242591182,
    Citizen: 4294759166,
    Clairitec: 4247203534,
    Coilcraft: 4291103310,
    CONEC: 4294759202,
    congatec: 4294398128,
    Corning: 4246760933,
    Cosel: 4287764468,
    Crouzet: 4294759251,
    Crystek: 4292773685,
    CSB: 4294759084,
    CTS: 4272799379,
    Dailywell: 4245109935,
    Dell: 4251602309,
    Delta: 4286307756,
    Deltron: 4292317937,
    Desco: 4294758686,
    DFRobot: 4248643702,
    Dialight: 4294759248,
    DiceKeys: 4244637759,
    DIGI: 4294759230,
    Digilent: 4282698358,
    DIOO: 4250706120,
    Diptronics: 4247871898,
    Displaytech: 4294759176,
    Duracell: 4294759083,
    EAO: 4286052022,
    Eaton: 4284899682,
    ECS: 4294759257,
    EDAC: 4294759207,
    EETools: 4294759224,
    eInfochips: 4293990203,
    Electroswitch: 4294759259,
    ELMOS: 4291156561,
    Elna: 4294759164,
    Emmoco: 4292270056,
    Epson: 4292828383,
    Espressif: 4248153906,
    Esquilo: 4273576447,
    Essentra: 4245902336,
    Eurotech: 4285999695,
    Everlight: 4294759196,
    Exascend: 4242856532,
    Extech: 4294759205,
    Fanstel: 4247898477,
    Fascomp: 4294759245,
    Fastron: 4294759172,
    Flambeau: 4294759012,
    Flex: 4294759076,
    FLIR: 4292569068,
    Fluke: 4294758872,
    Formerica: 4246809371,
    Fortebit: 4245700252,
    FRAMOS: 4245170243,
    FTDI: 4294759009,
    Fujitsu: 4294758988,
    Futaba: 4247401211,
    Genuino: 4256976807,
    GigaDevice: 4246117187,
    GIGAIPC: 4243391519,
    Glenair: 4294758149,
    Google: 4247429126,
    Gore: 4294758370,
    Gravitech: 4291607133,
    Grayhill: 4287829429,
    Greenlee: 4294758871,
    Greenliant: 4292831824,
    Gumstix: 4248095389,
    Hackboard: 4243391413,
    HackerGadgets: 4242522433,
    Hammond: 4294759173,
    Hantronix: 4294758966,
    HARTING: 4294758969,
    Harwin: 4294759008,
    HellermannTyton: 4248156419,
    Heraeus: 4288820906,
    Heyco: 4294758987,
    Hologram: 4247384138,
    Honeywell: 4294424657,
    Hyperstone: 4246041552,
    IBASE: 4286674219,
    IDEC: 4245164616,
    IEI: 4259554141,
    Ignion: 4246113706,
    ilumi: 4248450175,
    Industruino: 4248539013,
    Infineon: 4294759026,
    InnoPhase: 4245176511,
    Inolux: 4292990380,
    iNRCORE: 4247824900,
    Intel: 4290047598,
    InterFET: 4286186513,
    Intrinsyc: 4246110134,
    IoTize: 4243899009,
    Ioxus: 4292792262,
    ISSI: 4294758587,
    IXYS: 4294758873,
    Johanson: 4290297339,
    Jorjin: 4242495961,
    JST: 4287132237,
    Kamaya: 4294013539,
    KEMET: 4294762419,
    Kester: 4294759017,
    Keterex: 4292978383,
    Keysight: 4248295060,
    Kingbright: 4294758828,
    Kionix: 4292803520,
    Kioxia: 4246124777,
    Kneron: 4242900917,
    Knowles: 4293984106,
    Kobiconn: 4294758968,
    Kobitone: 4294758856,
    Kontron: 4246033879,
    KOSTAL: 4277405115,
    krtkl: 4247414937,
    Kycon: 4294758833,
    Kyocera: 4288413855,
    Laird: 4294758801,
    Lantronix: 4294758843,
    Lattice: 4294758842,
    LeaderTech: 4289423917,
    Ledil: 4292765307,
    Lelon: 4294758802,
    LEMO: 4294758863,
    Lime: 4245882847,
    Linklayer: 4244707119,
    Littelfuse: 4294759313,
    LoadSlammer: 4246712543,
    Loctite: 4246033045,
    Lorlin: 4294759098,
    LPRS: 4272876961,
    Lumex: 4294759194,
    Lumileds: 4279217008,
    Luxonis: 4245137082,
    M5Stack: 4243899778,
    MachineQ: 4246359448,
    MACOM: 4288761330,
    Marquardt: 4292119722,
    Marvell: 4247796992,
    MathStar: 4294758838,
    MaxLinear: 4294014054,
    Maxtena: 4244636138,
    mCube: 4285139929,
    meerecompany: 4242387161,
    Megger: 4294758791,
    Melexis: 4273581899,
    MEMSIC: 4249705771,
    Menda: 4294758685,
    Metcal: 4289574402,
    Meterman: 4294758847,
    Micrium: 4292725359,
    microbit: 4247497461,
    MicroCare: 4246033026,
    Microchip: 4294758776,
    Mide: 4290778819,
    Mikroe: 4292755921,
    Molex: 4294759208,
    Monnit: 4247449720,
    MonoDAQ: 4247515914,
    Mpression: 4248606198,
    MultiTech: 4245065192,
    Murata: 4294759241,
    NDK: 4247546505,
    NEC: 4294759040,
    NeoCortec: 4242478534,
    NetBurner: 4294758775,
    Neutrik: 4294758768,
    Nexcom: 4243780997,
    Nexperia: 4248677772,
    Nichicon: 4294759090,
    Nidec: 4245108466,
    NJR: 4294758758,
    NorComp: 4294758967,
    Noritake: 4294755166,
    NovTech: 4248137936,
    NXP: 4294758971,
    Ohmite: 4294759162,
    Olmatic: 4248516422,
    OmniPreSense: 4247535709,
    Omron: 4294759010,
    OncQue: 4294758778,
    Onion: 4248270572,
    onsemi: 4294759663,
    ORing: 4248294425,
    OTTO: 4290538936,
    PacTec: 4294759213,
    Panasonic: 4292890524,
    Panavise: 4294758868,
    PandaBoard: 4292747608,
    Panduit: 4294758830,
    Panjit: 4244879798,
    Parallax: 4294758655,
    Particle: 4253503268,
    PEM: 4244912754,
    Phihong: 4294759006,
    Pimoroni: 4247518813,
    Plato: 4294758867,
    Pletronics: 4292695494,
    Pomona: 4294759103,
    Powercast: 4292826680,
    PowerFilm: 4246121852,
    Protek: 4294758781,
    pSemi: 4247453640,
    PSP: 4292979899,
    Pulsar: 4292691770,
    Pulse: 4294759097,
    Pycom: 4248480313,
    Pyreos: 4247416603,
    Qorvo: 4282285770,
    Qualtek: 4294764023,
    Quectel: 4244894759,
    QuickLogic: 4244816640,
    Radiall: 4294576709,
    RAFI: 4248649487,
    REAN: 4292486909,
    RECOM: 4292363108,
    Rectron: 4294764380,
    Renata: 4294761406,
    RFMi: 4243892017,
    RIoTboard: 4288184214,
    Riverdi: 4246151226,
    ROBOTIS: 4248538960,
    Rosenberger: 4263553842,
    Rubycon: 4246773575,
    RushUp: 4248287922,
    Sagrad: 4294013510,
    Samsung: 4248637691,
    Samtec: 4294438777,
    SanDisk: 4263266499,
    SanRex: 4244696164,
    Schaffner: 4294764130,
    SchmartBoard: 4294759962,
    Schurter: 4294764378,
    ScioSense: 4245116175,
    SCS: 4281768760,
    SEARAN: 4246681605,
    SECO: 4245204609,
    SemiQ: 4244987184,
    Semitec: 4292707887,
    Semtech: 4274281261,
    Sensata: 4248568783,
    SensiEDGE: 4248482599,
    Sensirion: 4282697291,
    Sequans: 4244645369,
    SERPAC: 4294763565,
    Shindengen: 4294764331,
    SI: 4244554336,
    SiFive: 4244740338,
    Sigfox: 4247490860,
    Silego: 4284568550,
    Silicognition: 4245067341,
    Silicom: 4266808052,
    Silvertel: 4245204458,
    Simpson: 4294764286,
    SiTime: 4294406567,
    SkyeTek: 4294763655,
    Skyworks: 4292402259,
    SolaHD: 4294764256,
    SolderCore: 4292501438,
    SoMLabs: 4247403778,
    Sony: 4246151747,
    Souriau: 4294763307,
    SpotSee: 4244920693,
    SQFMI: 4242381767,
    Staco: 4294761396,
    StereoPi: 4244731835,
    steute: 4248516620,
    STMicroelectronics: 4294764375,
    Sumida: 4294761761,
    Sunbank: 4278733323,
    Sunon: 4248309420,
    Susumu: 4292902424,
    SVTronics: 4287814258,
    Swissbit: 4289485418,
    Switchcraft: 4294764127,
    SynDaver: 4245106866,
    Taica: 4267066522,
    Tamura: 4294758779,
    Taoglas: 4292687824,
    TDK: 4294758962,
    TechNexion: 4290847695,
    Techspray: 4294758570,
    Tektronix: 4294030715,
    Telink: 4242527039,
    Teltonika: 4244645344,
    Terabee: 4247493553,
    Terasic: 4291087185,
    Tianma: 4245512143,
    Tinkerforge: 4246771591,
    TinyCircuits: 4248593092,
    Toradex: 4245534241,
    Toshiba: 4294758568,
    Transphorm: 4246798347,
    Trinamic: 4245176463,
    UDOO: 4273582094,
    Ultraleap: 4245870718,
    Ultralife: 4294758366,
    UnitedSiC: 4248705612,
    Unspecified: 4294438824,
    UrsaLeo: 4248000271,
    Vacuumschmelze: 4291224639,
    Varitronix: 4294758645,
    VCC: 4294758824,
    Vector: 4294758571,
    Versarien: 4278845208,
    Vesper: 4247383284,
    Vicor: 4276286914,
    Virtium: 4247886488,
    Visaton: 4249708960,
    Vishay: 4294759685,
    Vitrohm: 4272931288,
    Volex: 4294759004,
    Walsin: 4294400163,
    Wandboard: 4290857236,
    Weidmuller: 4242583601,
    Wi2Wi: 4293998577,
    Wiha: 4294758866,
    WIMA: 4294759157,
    Winbond: 4247449098,
    Wiremold: 4294758890,
    Wittra: 4242900939,
    WIZnet: 4292589411,
    Xeltek: 4294759233,
    Xenarc: 4242647077,
    Xicon: 4294759688,
    Xidas: 4243781656,
    Xilinx: 4246742347,
    XinaBox: 4247489035,
    Xsens: 4283162860,
    Yageo: 4294759231,
    Zerynth: 4247806434,
    ZiLOG: 4294759235,
    Zipcores: 4246130721,
    ZSCircuits: 4244792133,
};
export const mouserManufacturerListLowercase = Object.fromEntries(Object.entries(mouserManufacturerList).map(([name, id]) => [name.toLowerCase(), id]));
// Mouser filter only accepts a single ID, so we take the shortest name match
export function mouserManufacturerIdBySubstring(substring) {
    substring = normalizeSubstring(substring);
    const keys = Object.keys(mouserManufacturerList)
        .filter((name) => name.toLowerCase().includes(substring))
        .sort((a, b) => a.length - b.length);
    return keys[0] ? mouserManufacturerList[keys[0]] : undefined;
}
//# sourceMappingURL=mouserManufacturerList.js.map